import { render } from "./CardReply.vue?vue&type=template&id=74bb8825&scoped=true"
import script from "./CardReply.vue?vue&type=script&lang=js"
export * from "./CardReply.vue?vue&type=script&lang=js"

import "./CardReply.vue?vue&type=style&index=0&id=74bb8825&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74bb8825"]])

export default __exports__